import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const SdFormat = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('sd_item1'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])

    return <div className="App">
        <div style={{ width: '100%' }}>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#333333', marginTop: 15, lineHeight: '22px', fontWeight: '500' }}>{t('sd_format_faq')}</span>
            </div>
            <div className="bind-device-faq-marginH20">
                <img src={`${CommonUtil.getSourceDomain()}sd_format.png`} alt="" style={{ width: '100%', marginLeft: 20, marginTop: 15 }} />
            </div>
        </div>
    </div>
}

export default SdFormat